export enum EvidenceCategory {
  'PHOTOGRAPH' = 'PHOTOGRAPH',
  'VIDEO' = 'VIDEO',
  'DOCUMENT' = 'DOCUMENT',
  'INVOICE' = 'INVOICE',
}
